import { ThunkType } from "../../../../core/store/reducers";
import { getMonthlyExcel } from "../api/getMonthlyExcel";
import fileDownload from "js-file-download";
import { setFetchState } from "../monthlyTradeDataSlice";
import moment from "moment";

export const downloadMonthlyExcel = (): ThunkType => async (
  dispatch,
  getStore
) => {
  const store = getStore();

  if (store.data.auth.current.status !== "successful") {
    return undefined;
  }

  const { filter } = store.ux.reports.monthlyTrade;
  const user = store.data.auth.current.user;
  dispatch(setFetchState({ type: "started" }));

  const monthlyTrading = await dispatch(getMonthlyExcel(user, filter));
  if (monthlyTrading) {
    fileDownload(
      new Blob([monthlyTrading as any], {
        type: "application/vnd.openxmlformat",
      }),
      "MonthlyTrading_" + moment().format("YYYYMMDDhhmmss") + ".xlsx"
    );
  }
  dispatch(setFetchState({ type: "not-started" }));
};
